import { createSlice, PayloadAction } from "@reduxjs/toolkit";
import type { RootState } from "../store";

interface InvestigationFilesState {
  investigationFileCount: number;
}

const initialState: InvestigationFilesState = {
  investigationFileCount: 0,
};

const investigationFilesSlice = createSlice({
  name: "investigationFiles",
  initialState,
  reducers: {
    incrementFileCount: (state, action: PayloadAction<string | number>) => {
      const key = String(action.payload);
      state.investigationFileCount = (state.investigationFileCount ?? 0) + 1;
    },
    decrementFileCount: (state, action: PayloadAction<string | number>) => {
      const key = String(action.payload);
      state.investigationFileCount = Math.max(
        (state.investigationFileCount ?? 0) - 1,
        0,
      );
    },
    setFileCount: (
      state,
      action: PayloadAction<{ count: number }>,
    ) => {
      state.investigationFileCount =
        action.payload.count;
    },
    resetFileCount: (state) => {
      state.investigationFileCount = 0;
    },
  },
});

export const {
  incrementFileCount,
  decrementFileCount,
  setFileCount,
  resetFileCount,
} = investigationFilesSlice.actions;

export const getFileCount =
  () => (state: RootState) =>
    state.investigationFiles.investigationFileCount ?? 0;

export default investigationFilesSlice.reducer;